import styled from 'styled-components';
import { getBaseTheme } from '@Themes';
import { theme } from '@Themes/themeOverriderFabric';

const { spaces, colors } = getBaseTheme();

export const ScoreCardAnalyticValueDiv = styled.div`
    display: inline-flex;
    margin: ${spaces.inset.xxs};
    background-color: ${props => props.highlighted && `${theme.palette.blueHighlight}`};

    .error {
        color: ${colors.area.active.backgroundColor};
    }

    > i {
        margin-right: ${spaces.default.s};
        color: ${colors.area.default.complementaryForegroundColor};
    }
`;
